/**
 * Aufgabe zurückstellen (Benjamin, 12.10.2026: „so dass sie mir in einer
 * auswählbaren Zeit erst wieder angezeigt werden"). Server: Migration 213,
 * `POST /notizen/{id}/zurueckstellen`. Ein Tag gilt ab 6 Uhr morgens.
 * Zurückgestellt ist nicht erledigt — die Aufgabe steht so lange unter „Später".
 */
import { useState } from "react";
import { fehlerText } from "@vimaana/ui";

import { useNotizZurueckstellen } from "../../hooks/useNotizen";

function tag(plus: number, basis = new Date()): string {
  const d = new Date(basis);
  d.setDate(d.getDate() + plus);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

function naechsterMontag(): string {
  const heute = new Date().getDay(); // 0 = Sonntag
  return tag(((8 - heute) % 7) || 7);
}

const WOCHENTAG = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

export function bisText(iso: string): string {
  const d = new Date(iso);
  return `${WOCHENTAG[d.getDay()]} ${d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" })}`;
}

export function ZurueckstellenWahl({ notizId, onClose }: { notizId: string; onClose: () => void }) {
  const stellen = useNotizZurueckstellen();
  const [datum, setDatum] = useState(tag(7));
  const setzen = (bis: string) => stellen.mutate({ id: notizId, bis }, { onSuccess: onClose });
  const wahl = [
    { label: "Morgen", bis: tag(1) },
    { label: "In 3 Tagen", bis: tag(3) },
    { label: "Montag", bis: naechsterMontag() },
    { label: "In 2 Wochen", bis: tag(14) },
  ];
  return (
    <div className="nz-spaeter" role="group" aria-label="Zurückstellen bis">
      <span className="nz-spaeter-titel">Wieder zeigen …</span>
      <div className="nz-spaeter-wahl">
        {wahl.map((w) => (
          <button key={w.label} type="button" className="nz-tat" disabled={stellen.isPending} onClick={() => setzen(w.bis)}>
            {w.label} <small>{bisText(`${w.bis}T06:00:00`)}</small>
          </button>
        ))}
      </div>
      <div className="nz-spaeter-wahl">
        <input type="date" className="nz-feld" value={datum} min={tag(1)} onChange={(e) => setDatum(e.target.value)} aria-label="Datum wählen" />
        <button type="button" className="nz-tat is-passend" disabled={!datum || stellen.isPending} onClick={() => setzen(datum)}>Zurückstellen</button>
        <button type="button" className="nz-still" onClick={onClose}>Abbrechen</button>
      </div>
      {stellen.error && <p className="nz-fehler" role="alert">{fehlerText(stellen.error)}</p>}
    </div>
  );
}

export function ZurueckgestelltHinweis({ notizId, bis }: { notizId: string; bis: string }) {
  const stellen = useNotizZurueckstellen();
  return (
    <p className="nz-spaeter-hinweis">
      Zurückgestellt bis {bisText(bis)}
      <button type="button" className="nz-still" disabled={stellen.isPending}
        onClick={() => stellen.mutate({ id: notizId, bis: null })}>Jetzt zeigen</button>
    </p>
  );
}
